export * from "ce/reducers/uiReducers";
import { uiReducerObject as CE_uiReducerObject } from "ce/reducers/uiReducers";
import { combineReducers } from "redux";
import moduleInstancePane from "./moduleInstancePaneReducer";
import gitExtendedReducer from "./gitExtendedReducer";
import workflowHistoryPane from "./workflowHistoryPaneReducer";
import moduleActiveActionsReducer from "./moduleActiveActionsReducer";
import workflowPluginReducer from "./workflowPluginReducer";
import { workflowIDEReducer } from "./workflowIDEReducer";
import packageIdeReducer from "./packageIDEReducer";

const uiReducer = combineReducers({
  ...CE_uiReducerObject,
  moduleInstancePane,
  gitExtended: gitExtendedReducer,
  workflowHistoryPane,
  workflowPlugin: workflowPluginReducer,
  moduleActiveActions: moduleActiveActionsReducer,
  workflowIDE: workflowIDEReducer,
  packageide: packageIdeReducer,
});

export default uiReducer;
